<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">技术支持：{{config.name}}</p>
    <p class="address_tel_fax">
      <span>地址：{{config.address}}</span>
      <!-- <span>Tel：{{config.phone}}</span> -->
    </p>
    <p class="email_wx">
      <span>邮箱：{{config.email}}</span>
      <span>联系电话：{{config.wechat}}</span>
    </p>
    <p class="copy">  
      <a class="beian-link" href="https://beian.miit.gov.cn/" target="_blank"
        >{{ config.keepOnRecordIcp }}</a
      > </p>
  </div>
</template>
<script>
import config from '@/config'
export default {
  name: "Footer",
  data() {
    return {
      config: config
    };
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 50px;
}
.logo img{
  width: 70px;
  height: auto;
}
.title {
  font-size: 20px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
.beian-link{
   color: #d3d3d3;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue